


import { useOutletContext } from "react-router-dom";
import { CustomDatePicker } from "../../../../components/CustomDatePicker";
import { CustomSelect } from "../../../../components/CustomSelect";
import CustomModal from "../../../../components/Modal/CustomModal";
import { useEffect } from "react";
import { createMealModel } from "../Model/MealModel";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * Modal component for selecting a cafeteria mealtime.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {boolean} props.show - Controls whether the modal is visible.
 * @param {Function} props.onHide - Callback fired when the modal should be closed.
 * @param {Function} props.onConfirm - Callback fired when the confirm button is clicked.
 * @param {boolean} [props.disabled=false] - If true, disables interactive elements in the modal.
 * @param {Array<Object>} props.mealtimes - List of available mealtimes to display in the select input.
 * @param {Function} props.handleChange - Callback to handle changes in the date or mealtime selection.
 * @param {boolean} props.emptyFields - validation flag.
 *
 * @returns {JSX.Element} The rendered SelectCoffeeShopModal component.
 *
 * @example
 * <SelectCoffeeShopModal
 *   show={true}
 *   onHide={() => setShow(false)}
 *   onConfirm={handleConfirm}
 *   disabled={false}
 *   mealtimes={[{ id: 1, name: 'Breakfast' }]}
 *   handleChange={handleFieldChange}
 *   emptyFields={true}
 * />
 */

const SelectCoffeeShopModal = ({
    show,
    onHide,
    onConfirm,
    disabled,
    mealtimes,
    handleChange,
    emptyFields
}) => {

    const { meal, setMeal } = useOutletContext()

    useEffect(() => {
        setMeal(createMealModel());
    }, [])

    return (
        <CustomModal
            buttonConfirm="confirm"
            cancelButton={true}
            confirmButton={true}
            display=""
            onConfirm={() => onConfirm()}
            onHide={onHide}
            show={show}
            size="lg"
            title="select_mealtime"
            className
        >
            <div className="row">
                <div className="col-12 col-lg-6">
                    <CustomDatePicker
                        id={"dtp_scsm_date"}
                        name="date"
                        trans="cafeteria_serving_date"
                        minDate={new Date()}
                        onChange={(value) =>
                            handleChange({ target: { name: "date", value } })
                        }
                        required={true}
                        emptyFields={emptyFields}
                        value={meal.date}
                        views={['day']}     // Only day in the selector
                        openTo="day"                 // Opens in day view
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <CustomSelect
                        id={"slt_scsm_mealtime"}
                        name="mealTime"
                        trans="meal_time"
                        list={mealtimes || []}
                        showNoSelectionOption={false}
                        keyName={"id"}
                        onChange={(selected) => handleChange({ target: { name: "mealTime", value: selected.target.value } })}
                        required={true}
                        emptyFields={emptyFields}
                        value={meal.mealTime || ''}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default SelectCoffeeShopModal;
